import {
  Card,
  Center,
  Container,
  Flex,
  HStack,
  Image,
  PinInput,
  PinInputField,
  Spacer,
  Text,
  VStack,
  Box,
  List,
  ListItem,
  ListIcon,
} from "@chakra-ui/react";
import React, { useCallback, useEffect, useState } from "react";
import CustomInput from "../components/CustomInput";
import { FiEye, FiEyeOff, FiCheck, FiX } from "react-icons/fi";
import { Link, useNavigate } from "react-router-dom";
import CustomButton1 from "../components/CustomButton1";
import {
  emailRegex,
  encryptData,
  errorMess,
  infoMess,
  passwordRegex,
  successMess,
} from "../utils/utils";
import { base_url, register, send_otp } from "../utils/apis";
import CustomModal from "../components/CustomModal";
import parse from "html-react-parser";
import store from "../redux/Store";
import { getUserData } from "../redux/slice/userSlice";

const Sigup = () => {
  const [checked, setChecked] = useState(false);
  const loggedInUser = localStorage.getItem("user");
  const [terms, setTerms] = useState(false);
  const user = JSON.parse(loggedInUser);
  const navigate = useNavigate();
  const [password, setPassword] = useState({
    value: "",
    validate: false,
    mess: "",
  });
  const [name, setName] = useState({ value: "", validate: false, mess: "" });
  const [mobile, setMobile] = useState({
    value: "",
    validate: false,
    mess: "",
  });
  const [email, setEmail] = useState({ value: "", validate: false, mess: "" });
  const [c_password, setC_password] = useState({
    value: "",
    validate: false,
    mess: "",
  });
  const [loading, setLoading] = useState(false);
  const [show, setShow] = React.useState(false);
  const [show1, setShow1] = React.useState(false);
  const [show_otp, setShow_otp] = useState(false);
  const [otp, setOtp] = useState("");
  const [id, setId] = useState("");
  const [latlon, setLatlon] = useState({});
  const [termData, setTermData] = useState("");
  const [disBtn, setDisBtn] = useState(false);
  const [timer, setTimer] = useState(0); // countdown timer state
  const [passwordStrength, setPasswordStrength] = useState({
    hasMinLength: false,
    hasUpperCase: false,
    hasLowerCase: false,
    hasNumber: false,
    hasSpecialChar: false,
  });

  // Check password strength whenever password changes
  useEffect(() => {
    const value = password.value;
    setPasswordStrength({
      hasMinLength: value.length >= 8,
      hasUpperCase: /[A-Z]/.test(value),
      hasLowerCase: /[a-z]/.test(value),
      hasNumber: /[0-9]/.test(value),
      hasSpecialChar: /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/.test(value),
    });
  }, [password.value]);

  useEffect(() => {
    let timeoutId;
    if (show_otp) {
      timeoutId = setTimeout(() => {
        setDisBtn(false);
      }, 60000);
    }
    return () => {
      if (timeoutId) clearTimeout(timeoutId);
    };
  }, [show_otp]);

  // countdown effect
  useEffect(() => {
    let intervalId;
    if (timer > 0) {
      intervalId = setInterval(() => {
        setTimer((prev) => prev - 1);
      }, 1000);
    }
    return () => clearInterval(intervalId);
  }, [timer]);

  const handleClick = () => setShow(!show);
  const handleClick1 = () => setShow1(!show1);

  const getMyLocation = () => {
    return new Promise((resolve, reject) => {
      const location = window.navigator && window.navigator.geolocation;
      if (location) {
        location.getCurrentPosition(
          (position) => {
            const coordinates = {
              latitude: position.coords.latitude,
              longitude: position.coords.longitude,
            };
            resolve(coordinates);
          },
          (error) => {
            reject(error);
          },
          { enableHighAccuracy: true, timeout: 20000, maximumAge: 1000 }
        );
      } else {
        reject("Geolocation not supported");
      }
    });
  };

  const validate = async () => {
    setLoading(5);
    const response = await getMyLocation()
      .then((coordinates) => coordinates)
      .catch(() => false);

    if (
      name.value.trim().length < 3 &&
      email.value.trim().length < 3 &&
      password.value.trim().length < 3 &&
      c_password.value.trim().length < 3 &&
      mobile.value.trim().length < 3
    ) {
      setPassword({
        ...password,
        validate: true,
        mess: "Password is required",
      });
      setEmail({ ...email, validate: true, mess: "Email address is required" });
      setMobile({
        ...mobile,
        validate: true,
        mess: "Mobile Number is required",
      });
      setC_password({
        ...c_password,
        validate: true,
        mess: "Confirm password is required",
      });
      setName({ ...name, validate: true, mess: "Name is required" });
      setLoading("");
      return;
    }

    if (name.value.length < 3) {
      setName({ ...name, validate: true, mess: "Name is required" });
      setLoading("");
      return;
    } else if (/^[^a-zA-Z]+$/.test(name.value.charAt(0))) {
      setName({
        ...name,
        validate: true,
        mess: "Name cannot start with special characters or spaces",
      });
      setLoading("");
      return;
    }
    if (mobile.value.length !== 10) {
      setMobile({
        ...mobile,
        validate: true,
        mess: "Please enter valid mobile number",
      });
      setLoading("");
      return;
    }
    if (!emailRegex.test(email.value)) {
      setEmail({
        ...email,
        validate: true,
        mess: "Invalid Email address",
      });
      setLoading("");
      return;
    }
    if (!passwordRegex.test(password.value)) {
      setPassword({
        ...password,
        validate: true,
        mess: "Password must be at least 8 characters long and contain at least one special character!",
      });
      setLoading("");
      return;
    }
    if (password.value !== c_password.value) {
      setC_password({
        ...c_password,
        validate: true,
        mess: "Confirm password did not match password",
      });
      setLoading("");
      return;
    }
    if (!id) {
      infoMess("Please request OTP first");
      setLoading("");
      return;
    }
    if (!otp) {
      infoMess("OTP is required, Please enter OTP");
      setLoading("");
      return;
    }
    if (!response) {
      infoMess("Location is required, Please turn on location");
      setLoading("");
      return;
    }

    const body = new FormData();
    body.append("name", name.value.trim());
    body.append("email", email.value.trim());
    body.append("contact", mobile.value.trim());
    // normalize id to string before sending (may be numeric)
    body.append("id", (id || "").toString().trim());
    body.append("otp", otp.trim());
    body.append("latlong", response?.latitude + "," + response?.longitude);
    body.append("password", encryptData(password.value.trim()));
    body.append("platform", "Web");
    body.append("type", "signup");

    console.log("Register Payload:", {
      name: name.value.trim(),
      email: email.value.trim(),
      contact: mobile.value.trim(),
      id,
      otp,
      latlong: response?.latitude + "," + response?.longitude,
    });

    try {
      const v = await register(body, setLoading);

      if (!v) {
        errorMess("No response from server");
        return;
      }

      if (v.success && v.userid) {
        // Final successful registration
        successMess(v.message || "Registered successfully");
        store.dispatch(getUserData(v.userid));
        localStorage.setItem("user", JSON.stringify(v));
        navigate("/");
      } else if (v.success && !v.userid) {
        // Only validation passed
        infoMess(v.message || "Validation passed!");
      } else {
        errorMess(v.message || "Signup failed. Please try again.");
      }
    } catch (err) {
      errorMess("Something went wrong. Please try again later.");
    } finally {
      setLoading("");
    }
  };

  useEffect(() => {
    getMyLocation();
  }, []);

  const checkKeyPress = useCallback(
    (e) => {
      if (e.keyCode === 13) validate();
    },
    [name, email, password, c_password, mobile, otp, id, latlon]
  );

  useEffect(() => {
    user !== null && navigate("/");
  }, []);

  useEffect(() => {
    window.addEventListener("keydown", checkKeyPress);
    return () => {
      window.removeEventListener("keydown", checkKeyPress);
    };
  }, [checkKeyPress]);

  const get_otp = async () => {
    if (mobile.value.length < 10) {
      setMobile({
        ...mobile,
        validate: true,
        mess: "Please enter valid mobile number",
      });
      return;
    }

    try {
      const v = await send_otp(mobile.value, setLoading, "signup");
      if (v && v.success) {
        successMess(v.message);
        // ensure id stored as string (server may return numeric id)
        setId(String(v.id || ""));
        setShow_otp(true);
        setDisBtn(true);
        setTimer(60); // start countdown
      } else {
        errorMess(v?.message || "Failed to send OTP");
        setShow_otp(false);
      }
    } catch (err) {
      errorMess("Something went wrong while sending OTP");
    }
  };

  const getterms = async () => {
    try {
      const responce = await fetch(base_url + "Terms.php", { method: "GET" });
      const res = await responce.json();
      if (res.success) {
        setTermData(res.data);
      } else {
        setTermData("");
      }
    } catch (error) {}
  };

  useEffect(() => {
    getterms();
  }, []);

  return (
    <Container
      w={"full"}
      h={"100vh"}
      maxW={"full"}
      bg={"#084480"}
      justifyContent={"center"}
      alignItems={"center"}
      display={"flex"}
      background={"url(bg.png) center/cover no-repeat"}
      overflow="hidden"
    >
      <VStack
        h={"full"}
        w={"full"}
        justify={"center"}
        align={"center"}
        display={["none", "none", "none", "flex"]}
      ></VStack>
      <VStack h={"full"} w={"full"} justify={"center"} align={"center"} py={4}>
        <Card
          px={5}
          w={["full", "lg"]}
          justify={"center"}
          py={6}
          maxH="90vh"
          overflow="hidden"
        >
          <Center>
            <Image src="logo1.jpeg" h={"3.5rem"} w={"100px"} borderRadius={5} />
          </Center>
          <Text fontSize={"lg"} textAlign={"center"} mt={2} color={"#000"}>
            Sign Up
          </Text>

          <Box
            maxH="calc(90vh - 180px)"
            overflowY="auto"
            pr={2}
            sx={{
              "&::-webkit-scrollbar": {
                width: "4px",
              },
              "&::-webkit-scrollbar-track": {
                width: "6px",
                background: "transparent",
              },
              "&::-webkit-scrollbar-thumb": {
                background: "gray.300",
                borderRadius: "24px",
              },
            }}
          >
            <CustomInput
              placeholder="Name"
              value={name.value}
              onChange={(e) =>
                setName({
                  ...name,
                  value: e.target.value,
                  validate: false,
                  mess: "",
                })
              }
              isInvalid={name.validate}
              error={name.mess}
              size="sm"
            />
            <CustomInput
              placeholder="Mobile Number"
              value={mobile.value}
              onChange={(e) => {
                e.target.value.length < 11 &&
                  setMobile({
                    ...mobile,
                    value: e.target.value.replace(/\D/g, ""),
                    validate: false,
                    mess: "",
                  });
              }}
              isInvalid={mobile.validate}
              error={mobile.mess}
              rightButton={
                <Center mt={1}>
                  <CustomButton1
                    title={
                      timer > 0
                        ? `Resend in ${timer}s`
                        : show_otp
                        ? "Resend OTP"
                        : "Get OTP"
                    }
                    loading={loading == 1}
                    onClick={get_otp}
                    disabled={timer > 0}
                    size="sm"
                  />
                </Center>
              }
              size="sm"
            />
            {show_otp && (
              <HStack justify={"center"} mt={2} mb={1}>
                <PinInput
                  placeholder="-"
                  autoFocus
                  value={otp}
                  onChange={setOtp}
                  size="sm"
                >
                  <PinInputField py={2} />
                  <PinInputField py={2} />
                  <PinInputField py={2} />
                  <PinInputField py={2} />
                  <PinInputField py={2} />
                  <PinInputField py={2} />
                </PinInput>
              </HStack>
            )}
            <CustomInput
              placeholder="Email ID"
              value={email.value}
              onChange={(e) =>
                setEmail({
                  ...email,
                  value: e.target.value,
                  validate: false,
                  mess: "",
                })
              }
              isInvalid={email.validate}
              error={email.mess}
              size="sm"
            />

            <CustomInput
              placeholder="Password"
              type={show ? "text" : "password"}
              value={password.value}
              onChange={(e) =>
                setPassword({
                  ...password,
                  value: e.target.value,
                  validate: false,
                  mess: "",
                })
              }
              isInvalid={password.validate}
              error={password.mess}
              right={
                !show ? (
                  <FiEye cursor={"pointer"} size={16} onClick={handleClick} />
                ) : (
                  <FiEyeOff
                    cursor={"pointer"}
                    size={16}
                    onClick={handleClick}
                  />
                )
              }
              size="sm"
            />

            {/* Password Strength Indicator */}
            {password.value && (
              <Box
                mt={2}
                mb={2}
                p={2}
                bg="gray.50"
                borderRadius="md"
                fontSize="xs"
              >
                <Text fontWeight="medium" mb={1}>
                  Password must contain:
                </Text>
                <Flex>
                  <Box flex="1" pr={1}>
                    <List spacing={0.5}>
                      <ListItem display="flex" alignItems="center">
                        <ListIcon
                          as={passwordStrength.hasMinLength ? FiCheck : FiX}
                          color={
                            passwordStrength.hasMinLength
                              ? "green.500"
                              : "red.500"
                          }
                          fontSize="12px"
                        />
                        <Text fontSize="xs">8+ characters</Text>
                      </ListItem>
                      <ListItem display="flex" alignItems="center">
                        <ListIcon
                          as={passwordStrength.hasUpperCase ? FiCheck : FiX}
                          color={
                            passwordStrength.hasUpperCase
                              ? "green.500"
                              : "red.500"
                          }
                          fontSize="12px"
                        />
                        <Text fontSize="xs">Uppercase letter</Text>
                      </ListItem>
                      <ListItem display="flex" alignItems="center">
                        <ListIcon
                          as={passwordStrength.hasLowerCase ? FiCheck : FiX}
                          color={
                            passwordStrength.hasLowerCase
                              ? "green.500"
                              : "red.500"
                          }
                          fontSize="12px"
                        />
                        <Text fontSize="xs">Lowercase letter</Text>
                      </ListItem>
                    </List>
                  </Box>
                  <Box flex="1" pl={1}>
                    <List spacing={0.5}>
                      <ListItem display="flex" alignItems="center">
                        <ListIcon
                          as={passwordStrength.hasNumber ? FiCheck : FiX}
                          color={
                            passwordStrength.hasNumber ? "green.500" : "red.500"
                          }
                          fontSize="12px"
                        />
                        <Text fontSize="xs">Number</Text>
                      </ListItem>
                      <ListItem display="flex" alignItems="center">
                        <ListIcon
                          as={passwordStrength.hasSpecialChar ? FiCheck : FiX}
                          color={
                            passwordStrength.hasSpecialChar
                              ? "green.500"
                              : "red.500"
                          }
                          fontSize="12px"
                        />
                        <Text fontSize="xs">Special character</Text>
                      </ListItem>
                    </List>
                  </Box>
                </Flex>
              </Box>
            )}

            <CustomInput
              placeholder="Confirm Password"
              type={show1 ? "text" : "password"}
              value={c_password.value}
              onChange={(e) =>
                setC_password({
                  ...c_password,
                  value: e.target.value,
                  validate: false,
                  mess: "",
                })
              }
              isInvalid={c_password.validate}
              error={c_password.mess}
              right={
                !show1 ? (
                  <FiEye cursor={"pointer"} size={16} onClick={handleClick1} />
                ) : (
                  <FiEyeOff
                    cursor={"pointer"}
                    size={16}
                    onClick={handleClick1}
                  />
                )
              }
              size="sm"
            />
            <Flex gap={1} paddingBlock={1} alignItems={"center"} fontSize="sm">
              <Text fontSize={"sm"} color={"#000"}>
                By clicking Sign Up, you agree to our
              </Text>
              <Text
                fontSize={"sm"}
                color={"#385898"}
                cursor={"pointer"}
                onClick={() => setTerms(true)}
              >
                Terms and Condition
              </Text>
            </Flex>
          </Box>

          <Center mt={3}>
            <CustomButton1
              title={"Sign Up"}
              loading={loading == 5}
              onClick={validate}
              size="sm"
            />
          </Center>
          <Link
            to={"/login"}
            style={{
              textAlign: "center",
              marginTop: 8,
              fontSize: "14px",
              color: "#e0a604",
              alignSelf: "center",
            }}
          >
            Already have an account?
          </Link>
        </Card>
      </VStack>
      <CustomModal
        isOpen={terms}
        onClose={() => setTerms(false)}
        body={
          <>
            <Text
              fontSize={"xl"}
              color={"#385898"}
              fontWeight={"medium"}
              textAlign={"center"}
            >
              Terms and condition
            </Text>
            <Spacer h={2} />
            <Text fontSize={"md"} color={"#000"}>
              {parse(termData)}
            </Text>
          </>
        }
      />
    </Container>
  );
};

export default Sigup;
